import { FontItem } from '../types';

/**
 * Built-in fonts that can be downloaded from the app's public folder.
 * Place the actual .ttf files in `public/fonts/` before building.
 *
 * Free fonts with open licenses suitable for redistribution:
 * - 霞鹜文楷 (LXGW WenKai): OFL, ~12MB — excellent for handwriting practice
 * - 思源宋体 (Source Han Serif): OFL, ~16MB
 * - 全字库正楷体 (TW-Kai): OFL, ~18MB
 */
export const BUILT_IN_FONTS: FontItem[] = [
  {
    id: 'built-in-zhongqizhi-mangxingshu',
    name: '钟齐志莽行书',
    desc: '免费字体',
    family: '钟齐志莽行书',
    isCustom: false,
    isBuiltIn: true,
    url: './fonts/钟齐志莽行书.ttf',
  },
  {
    id: 'built-in-qiantu-xianmo',
    name: '千图纤墨体',
    desc: '免费字体',
    family: '千图纤墨体',
    isCustom: false,
    isBuiltIn: true,
    url: './fonts/千图纤墨体.ttf',
  },
  {
    id: 'built-in-hongleibanshujianti',
    name: '鸿雷板书简体',
    desc: '免费字体',
    family: '鸿雷板书简体',
    isCustom: false,
    isBuiltIn: true,
    url: './fonts/鸿雷板书简体-正式版.ttf',
  },
  {
    id: 'built-in-yingzhui-xingshu',
    name: '英椎行书',
    desc: '免费字体',
    family: '英椎行书',
    isCustom: false,
    isBuiltIn: true,
    url: './fonts/YingZhuiXingShu.ttf',
  },
  {
    id: 'built-in-yuorenxiaoke',
    name: '悠然小凯',
    desc: '免费字体',
    family: '悠然小凯',
    isCustom: false,
    isBuiltIn: true,
    url: './fonts/YanShiYouRanXiaoKai.ttf',
  },
];
